// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content_wrapper__22omq","fullWidth":"Content_fullWidth__VXqKL"};